import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useModuleProgress from '../hooks/useModuleProgress';
import '../styles/pages/_module-pages.scss';
import '../styles/pages/_quiz-completion.scss';

const quizQuestions = [
  {
    question: "Which pillar of engagement is about being energized and ready to work?",
    options: [
      "Dedication",
      "Absorption",
      "Vigor",
      "Routine"
    ],
    correctAnswer: 2,
    explanation: "Vigor is about being energized and ready to work."
  },
  {
    question: "What is the 'Flow' state?",
    options: [
      "When challenge and skill meet, creating deep focus and enjoyment",
      "When you are bored at work",
      "When you multitask all day",
      "When you avoid all challenges"
    ],
    correctAnswer: 0,
    explanation: "The 'Flow' state is when challenge and skill meet, creating deep focus and enjoyment."
  },
  {
    question: "Which practice helps reconnect with your 'why' at work?",
    options: [
      "Dedication Practice",
      "Vigor Booster",
      "Absorption Routine",
      "None of the above"
    ],
    correctAnswer: 0,
    explanation: "Dedication Practice helps you reconnect with your 'why' at work."
  },
  {
    question: "How can you increase engagement at work?",
    options: [
      "Set personal goals and celebrate achievements",
      "Ignore your progress",
      "Avoid teamwork",
      "Work without breaks"
    ],
    correctAnswer: 0,
    explanation: "Setting personal goals and celebrating achievements can increase engagement at work."
  },
  {
    question: "Reigniting work engagement can help you:",
    options: [
      "Feel more motivated and connected to your work",
      "Become more bored",
      "Work less effectively",
      "Ignore your purpose"
    ],
    correctAnswer: 0,
    explanation: "Reigniting work engagement helps you feel more motivated and connected to your work."
  }
];

const OccupationalModule3QuizPage: React.FC = () => {
  const navigate = useNavigate();
  const { saveProgress } = useModuleProgress('occupationalM3');
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState<number | null>(null);
  const [showExplanation, setShowExplanation] = useState(false);
  const [showCompletion, setShowCompletion] = useState(false);

  const handleAnswerSelect = (index: number) => {
    if (selectedAnswer === null) {
      setSelectedAnswer(index);
      setShowExplanation(true);
    }
  };

  const handleNext = async () => {
    if (currentQuestion < quizQuestions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
      setSelectedAnswer(null);
      setShowExplanation(false);
    } else {
  await saveProgress(quizQuestions.length, true); // Mark module as completed
      setShowCompletion(true);
    }
  };

  const handleBack = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
      setSelectedAnswer(null);
      setShowExplanation(false);
    }
  };

  if (showCompletion) {
    return (
      <div className="quiz-completion-section">
        <h2 className="completion-title">
          <span>Congratulations!</span>
        </h2>
        <p className="completion-subtitle">You've completed the Module 3 quiz!</p>
        <div className="completion-card">
          <div className="achievement-section">
            <h3 className="section-title">
              <span>Key Achievements</span>
            </h3>
            <ul className="achievement-list">
              <li><span className="check"></span> Understanding engagement pillars</li>
              <li><span className="check"></span> Recognizing the Flow state</li>
              <li><span className="check"></span> Reconnecting with purpose</li>
            </ul>
          </div>
          <button className="resource-button" onClick={() => navigate('/panel/learn/occupational-resources')}>Return to Resources</button>
        </div>
      </div>
    );
  }

  const currentQuiz = quizQuestions[currentQuestion];
  return (
    <div className="module-form">
      <div className="module-container">
        <div className="module-left occupational-panel">
          <div className="module-header">
            <h1>Module 3 Quiz</h1>
            <p className="module-subtitle">Reigniting Work Engagement</p>
            <hr className="module-divider" />
            <p className="module-tool-info">Test your understanding of engagement, energy, and purpose at work.</p>
          </div>
        </div>
        <div className="assessment-right-panel">
          <div className="assessment-content">
            <div className="module-progress">
              <div className="progress-bar">
                <div className="progress-fill" style={{ width: `${((currentQuestion + 1) / quizQuestions.length) * 100}%` }}></div>
              </div>
              <span className="progress-text">Question {currentQuestion + 1} of {quizQuestions.length}</span>
            </div>
            <div className="question-section">
              <h2 className="question-title">{currentQuiz.question}</h2>
              <div className="answer-options">
                {currentQuiz.options.map((option, idx) => (
                  <label key={idx} className="answer-option">
                    <input
                      type="radio"
                      name={`question-${currentQuestion}`}
                      value={idx}
                      checked={selectedAnswer === idx}
                      onChange={() => handleAnswerSelect(idx)}
                      disabled={selectedAnswer !== null}
                    />
                    <span className="option-text">{option}</span>
                  </label>
                ))}
              </div>
              {showExplanation && (
                <div className="explanation">
                  <h3>{selectedAnswer === currentQuiz.correctAnswer ? 'Correct!' : 'Remember:'}</h3>
                  <p>{currentQuiz.explanation}</p>
                </div>
              )}
            </div>
            <div className="navigation-buttons">
              <button className="btn-secondary" onClick={currentQuestion === 0 ? () => navigate('/panel/learn/occupational-resources') : handleBack}>
                {currentQuestion === 0 ? 'Exit Quiz' : 'Previous Question'}
              </button>
              {currentQuestion < quizQuestions.length - 1 ? (
                <button className="btn-primary" onClick={handleNext} disabled={selectedAnswer === null}>Next Question</button>
              ) : (
                <button className="btn-primary" onClick={handleNext} disabled={selectedAnswer === null}>Complete Quiz</button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OccupationalModule3QuizPage;


